import { useSuspenseQuery } from "@tanstack/react-query";
import { Link } from "@tanstack/react-router";
import {
  cn,
  getPartnerEventName,
  PartnerEvents,
  queries,
  useAuthConfig,
} from "@theprelude/core";
import { Button, ServerIcon } from "@theprelude/ds";
import { outOfDateScanOData } from "@/components/filter-form/additional-filters";
import { getOdataFilters } from "@/components/filter-form/odata";
import { Filter } from "@/lib/filter";
import { tb } from "@/lib/tracking";
import { useExceptedFilters } from "@/queries/control-monitor";
import { getNavigationOptions, Metric } from "../sections";
import { SummaryStatusIcon } from "../summary-icon-bubbles";
import { SingleMetricCard } from "./single-metric-card";

export const DeviceOutOfDateScanCard = () => {
  const filters = useOutOfDateScanFilters();
  const { showExcepted } = useExceptedFilters();

  const authConfig = useAuthConfig();
  const { data: summary } = useSuspenseQuery(
    queries.scm.summary(authConfig, {
      endpointsQuery: {
        filter: { and: getOdataFilters(filters) },
      },
    }),
  );
  const count = showExcepted
    ? summary.endpoint_summary.endpoint_count
    : summary.endpoint_summary.excepted.endpoint_count;

  const title = getPartnerEventName(PartnerEvents.OUT_OF_DATE_SCAN);

  return (
    <SingleMetricCard
      icon={<SummaryStatusIcon success={count === 0} />}
      title={title}
      description="Devices not scanned for vulnerabilities recently."
      metric={<Metric label="Devices" count={count} />}
    >
      <div className="flex items-center gap-4">
        <Link
          {...getNavigationOptions({ overlay: ["endpoints", { filters }] })}
        >
          <Button
            intent="secondary"
            icon={<ServerIcon className="text-secondary-foreground" />}
            className={cn("inline-flex", tb(title))}
          >
            View devices
          </Button>
        </Link>
      </div>
    </SingleMetricCard>
  );
};

const useOutOfDateScanFilters = (): Filter[] => [
  { ...outOfDateScanOData, operator: "is", value: true },
];
